export default __webpack_public_path__ + "static/media/maarynara.8065a62c.jpg";